import { NgModule } from '@angular/core';
import { TagLabelListComponent } from './tag-label-list.component';

@NgModule({
  imports: [TagLabelListComponent],
  exports: [TagLabelListComponent]
})
export class TagLabelListModule {}
